import {
    GESTION_OPERATIVA_GET_COTIZACION_BEGIN,
    GESTION_OPERATIVA_GET_COTIZACION_SUCCESS,
    GESTION_OPERATIVA_GET_COTIZACION_FAILURE,
    GESTION_OPERATIVA_GET_COTIZACION_DISMISS_ERROR,
} from '../constants'

export function reducer(state, action) {
    switch (action.type) {
    case GESTION_OPERATIVA_GET_COTIZACION_BEGIN:
        // Just after a request is sent
        return {
        ...state,
        getCotizacionPending: true,
        getCotizacionError: null,
        }

    case GESTION_OPERATIVA_GET_COTIZACION_SUCCESS:
        // The request is success

        return {
        ...state,
        getCotizacionPending: false,
        getCotizacionError: null,
        takingCarFormData: null
        }

    case GESTION_OPERATIVA_GET_COTIZACION_FAILURE:
        // The request is failed
        return {
        ...state,
        getCotizacionPending: false,
        getCotizacionError: action.data.error,
        takingCarFormData: action.data.takingCarFormData
        }
        
        case GESTION_OPERATIVA_GET_COTIZACION_DISMISS_ERROR:
        // Dismiss the request failure error
        return {
            ...state,
        getCotizacionPending: false,
        getCotizacionError: null,
        takingCarFormData: null
        }

    default:
        return state
    }
}